export const typesLogin = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
};

export const typesRegister = {
  REGISTER: "REGISTER USER",
};

export const typesWorkout = {
  LIST: "GET WORKOUTS",
  ADD_WORKOUT: "ADD WORKOUT",
  DELETE_WORKOUT: "DELETE WORKOUT",
  UPDATE_WORKOUT: "UPDATE WORKOUT",
  GET_WORKOUT: "GET WORKOUT",
};
